import React from "react";
import Icon_Error from "../../assets/Icon_Error.svg";
import { Link, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "config";
import { signOut } from "reducers/auth";
import { useDispatch } from "react-redux";

const ErrorFallback: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signOutUserAndRedirect = () => {
    dispatch(signOut());
    navigate(APP_ROUTES.signIn);
    window.location.reload();
  };

  return (
    <div className="ErrorPage">
      <div className="ErrorCell">
        <div className="Img">
          <img src={Icon_Error} alt="Error" />
        </div>
        <div className="Txt">
          <h1>Something went wrong</h1>
          <p>
            Please try again. If the error persists, please contact support.
          </p>

          <div className="SignInRedirect" onClick={signOutUserAndRedirect}>
            Go to the Sign in page
          </div>

          {/* <Link to={APP_ROUTES.signIn}></Link> */}
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
